<template>
    <div class="modal-content  setup-rules">
        <div class="modal-header">

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span class="ico-cross"></span>
            </button>
        </div>

        <div class="modal-body">
            <div class="modal-title">
                <h5>Setup general rules for your employees</h5>
                <p class="gray-text">The rules are complied with when you let CleverStaff do the planning for you.
                    At the same time,
                    we keep an eye on your rules during your own planning. Click on an employee at the left to
                    create specific rules.</p>
            </div>
            <div class="rules-check-holder">
                <div class="rule-check" v-for="(item,index) in list">
                    <div class="sticky-check">
                        <label class="custom-check-box check-box-cus ">
                            <input type="checkbox" v-bind:checked="true" class="type" :value="item.type"   />
                            <input type="hidden"  class="titleValue" :value="item.title"  >
                            <span class="radio-check">{{item.title}}</span>
                        </label>
                    </div>
                    <div class="hour-enter">
                        <input type="number" min="0" class=" form-control form-control-sm number"   :value="item.number"   >
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button style="display: none" type="button" ref="Close" data-dismiss="modal">

            </button>
            <button  @click="submitFormRules" class="btn btn-primary btn-sm" data-dismiss="modal" aria-label="Close">Save </button>
        </div>

    </div>

</template>
<script>

    import moment from 'moment'
    import router from '../../router/router'
    import axios from "axios";

    export default {
        name: 'rules',
        data() {
            return {
                list: [
                    { id: 1, title: "Max. hours per day", type: 'max-hours-per-day',number:12 },
                    { id: 2, title: "Max. number of hours per week", type: 'max-hours-per-week',number:40 },
                    { id: 3, title: "Max. workdays in a row", type: 'max-workdays-in-row',number:5},
                    { id: 4, title: "Min. number of hours per week", type: 'min-hours-per-week',number:15 }
                ],
                responses:[],
                company_id: this.$store.getters.getSelectedCompany.id,
                form: {
                    company_id:this.$store.getters.getSelectedCompany.id,
                    type:[],
                    title:[],
                    number:[],
                },

            }
        },

        serverPrefetch() {

        },
        created() {
            this.getRulesViolation();
        },
        mounted() {

        },

        methods: {
            getRulesViolation(){
                let params = {
                    company_id: this.company_id,
                };

                this.$axios.get(this.$GeneralRulesViolation, {
                    params: params,
                    headers: this.getAuthHeader(),
                }).then(res => {
                    if (res.data.status == 200) {
                      this.$emit('rulesViolation',res.data.result.rules_violation)
                        if(res.data.result.rules_violation.length>0){
                            this.list=res.data.result.rules_violation;
                            // res.data.result.rules_violation.forEach((el,index)=>{
                            //     this.list.push({id: 1, title: el.title, type: el.type,number:el.number})
                            // });
                        }
                       // this.list = res.data.result;
                    }
                });
            },

            submitFormRulesbk() {
              axios.post(this.$GeneralRulesViolation,
                {company_id:this.form.company_id}
                , {headers: this.getAuthHeader()})
                .then((res) => {
                  if (res.status == 200) {
                    // this.$router.go(0);
                  }
                  //Perform Success Action
                })
                .catch((error) => {
                  // error.response.status Check status code
                }).finally(() => {
                //Perform action in always
              });

            this.$emit('submitRules',1)
            this.$refs.Close.click();
          },
            submitFormRules() {
                this.form.type=[];
                this.form.title=[];
                this.form.number=[];

                var types = document.querySelectorAll('.type');
                types.forEach((el,key)=>{
                    this.form.type.push(types[key].value);
                });
                var titles = document.querySelectorAll('.titleValue');
                titles.forEach((el,key)=>{
                    this.form.title.push(titles[key].value);
                });
                var numbers = document.querySelectorAll('.number');
                numbers.forEach((el,key)=>{
                    this.form.number.push(numbers[key].value);
                });
                this.form.type.forEach((sc,index) => {
                    axios.post(this.$GeneralRulesViolation,
                        {type:this.form.type[index],title:this.form.title[index],number:this.form.number[index],company_id:this.form.company_id}
                        , {headers: this.getAuthHeader()})
                        .then((res) => {
                            if (res.status == 200) {
                               // this.$router.go(0);
                            }
                            //Perform Success Action
                        })
                        .catch((error) => {
                            // error.response.status Check status code
                        }).finally(() => {
                        //Perform action in always
                    });

                });
                this.$emit('submitRules',1)
                this.$refs.Close.click();
            },
        }
    }
</script>
<style>
    .check-box-cus span:after{
        content: "\2713" !important;
    }
</style>

